import {
  CHECK_ONBOARDING_STATUS,
  COMPLETE_ONBOARDING,
  CLEAR_ONBOARDING_FLAGS,
  RESET_ONBOARDING_STATE,
  SET_POST_ONBOARDING_VISIBLE,
} from "../../modules/constants";

// ------------------------------------
// Action Creators
// ------------------------------------

export const checkOnboardingStatus = () => ({
  type: CHECK_ONBOARDING_STATUS,
});

export const completeOnboarding = (payload) => ({
  type: COMPLETE_ONBOARDING,
  payload,
});

export const clearOnboardingFlags = () => ({
  type: CLEAR_ONBOARDING_FLAGS,
});

export const resetOnboardingState = () => ({
  type: RESET_ONBOARDING_STATE,
});

export const setPostOnboardingVisible = (visible) => ({
  type: SET_POST_ONBOARDING_VISIBLE,
  payload: visible,
});
